export class UserProfile {
    memberId: number;
    userId: number;
    memberName: string;
    memberNameArabic: string;
    memberPosition: string;
    memberPositionCode: string;
    email: string;
    mobileNumber: string;
    tokenString: string;
    status: boolean;
}